
import './App.css';
import Home from './components/Home';
import { Provider } from 'react-redux';
import { noteStore } from './store/noteStore';
import Card from './components/Card';
import Forms from './components/Forms';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import  HomeNew  from './components/HomeNew';
import { Contact } from './components/Contact';
import NavBar from './components/NavBar';
import Header from './components/Header';
import Footer from './components/Footer';


function App() {
  return (
    <Provider store={noteStore}>
      <BrowserRouter>
      {/* <NavBar/> */}
      <Header/>
      <Routes>
        <Route path='/' element={<HomeNew/>} />
        <Route path='/about' element={<Forms/>} />
        <Route path='/contact' element={<Contact/>} />
      </Routes>
      <Footer/>
      </BrowserRouter>

      {/* <Forms/> */}
   {/* <Home/> */}

   </Provider>
  );
}

export default App;
